import { Boolean, Literal, Null, Number, Record, Static, String } from 'runtypes';

import { createEnumGuard } from 'src/models/enumGuard';
import { PresenceEnum as _PresenceEnum } from 'src/models/userOnlineList/enums';

const PresenceRunType = createEnumGuard(Object.values(_PresenceEnum) as _PresenceEnum[]);

export const UserOnlineListItemRunType = Record({
	id: String,
	name: String,
	presence: PresenceRunType,
	presenceSort: String,
	stateAutomaticIconCls: String.Or(Null),
	stateAutomaticIconColorHex: String.Or(Null),
	stateBackgroundColorHex: String.Or(Null),
	stateIconCls: String.Or(Null),
	stateIconColorHex: String.Or(Null),
	stateText: String.Or(Null),
	stateType: String.Or(Null),
	userAvatar: String.Or(Null),
});

export type UserOnlineListItem = Static<typeof UserOnlineListItemRunType>;
export const UserStateRunType = Record({
	hexCode: String,
	iconCls: String,
	id: Number,
	selectedState: Boolean,
	text: String.Or(Null),
	type: Literal('available').Or(Literal('global')).Or(Literal('personal')),
});

export type UserState = Static<typeof UserStateRunType>;
